/*
    EX-1081 :
    Added mutation observer to re-initialize togglers when new content is added to the page
    this change was added mainly for the reviews sections, where the content is added after the page loads
*/

const containerElement = '.js-toggle-container';
const contentElement = '.js-toggle-content';
const buttonElement = '.js-toggle-button';

const handleToggleClick = (e) => {
    const container = e.target.closest(containerElement);
    container.querySelector(contentElement).classList.toggle('is-open');
    container.querySelector(buttonElement).classList.toggle('is-open');
    container.classList.toggle('is-open');
};

const toggleContentInit = function() {
    document.querySelectorAll(buttonElement).forEach((button) => {
        button.removeEventListener('click', handleToggleClick);
    });

    document.querySelectorAll(buttonElement).forEach((button) => {
        button.addEventListener('click', handleToggleClick);
    });
};

// initialize togglers on page load
window.toggleContentInit = toggleContentInit;
toggleContentInit();

// re-initialize togglers when content changes
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
            toggleContentInit();
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
